export default __webpack_public_path__ + "static/media/first.c3e0cf7d.svg";